import type { ClientOptions } from "ably";
import type { ToxiproxyConfig } from "../core/types";

type AblyToxiproxyOverrides = Pick<
	ClientOptions,
	"endpoint" | "port" | "tls" | "tlsPort" | "disableConnectivityCheck" | "fallbackHosts"
>;

export function getAblyToxiproxyOverrides(
	config: ToxiproxyConfig | undefined,
	clientId?: string,
): AblyToxiproxyOverrides {
	if (!config?.enabled) {
		return {};
	}

	const enabledClientIds = config.clientIds ?? [];

	if (enabledClientIds.length > 0 && (!clientId || !enabledClientIds.includes(clientId))) {
		return {};
	}

	return {
		...(config.endpoint ? { endpoint: config.endpoint } : {}),
		...(typeof config.port === "number" ? { port: config.port } : {}),
		...(typeof config.tls === "boolean" ? { tls: config.tls } : {}),
		...(typeof config.tlsPort === "number" ? { tlsPort: config.tlsPort } : {}),
		...(typeof config.disableConnectivityCheck === "boolean"
			? { disableConnectivityCheck: config.disableConnectivityCheck }
			: {}),
		// Prevent the Ably SDK from falling back to *.ably-realtime.com fallback hosts
		// which are not covered by /etc/hosts and would bypass the proxy entirely.
		fallbackHosts: [],
	};
}
